// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-lab-page {
  background-color: #F5F9FE;
  padding: 40px 109px;
  height: calc(100dvh - 170px);
  overflow-x: auto;
}
.comparison-lab-page-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}
.comparison-lab-page-header h2 {
  font-family: Campuni;
  font-weight: bold;
  font-size: 24px;
  color: var(--sebrae-blue-6);
}
.comparison-lab-page-header p {
  font-family: Figtree;
  font-size: 16px;
  line-height: 23.3px;
}
.comparison-lab-page-header-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.comparison-lab-page-header-text button {
  height: 46px;
}
.comparison-lab-page-header-text-logo {
  display: flex;
  align-items: center;
  gap: 16px;
}
.comparison-lab-page-header-text-logo img {
  width: 209px;
  height: 20px;
}
.comparison-lab-page-header-text-logo .large {
  font-size: 33px;
}
.comparison-lab-page-content-button {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 24px;
  height: 64px;
}
.comparison-lab-page-content-button button:first-child {
  border-radius: 100px;
  height: 40px;
}
.comparison-lab-page-content-button div {
  display: flex;
  flex-direction: column;
  align-items: end;
}
.comparison-lab-page-content-button div button {
  border-radius: 4px !important;
}

.danger-text {
  color: #BF303C;
  margin-bottom: 8px;
}

.no-margin {
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/comparison-lab/index.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AACJ;AACI;EACE,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AACN;AAEI;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;AAAN;AAGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AADN;AAGM;EACE,YAAA;AADR;AAIM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFR;AAIQ;EACE,YAAA;EACA,YAAA;AAFV;AAIQ;EACE,eAAA;AAFV;AASI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AAPN;AASM;EACE,oBAAA;EACA,YAAA;AAPR;AAUM;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AARR;AAUQ;EACE,6BAAA;AARV;;AAeA;EACE,cAAA;EACA,kBAAA;AAZF;;AAeA;EACE,kBAAA;AAZF","sourcesContent":[".comparison-lab-page {\n  background-color: #F5F9FE;\n  padding: 40px 109px;\n  height: calc(100dvh - 170px);\n  overflow-x: auto;\n\n  &-header {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 24px;\n\n    h2 {\n      font-family: Campuni;\n      font-weight: bold;\n      font-size: 24px;\n      color: var(--sebrae-blue-6);\n    }\n\n    p {\n      font-family: Figtree;\n      font-size: 16px;\n      line-height: 23.3px;\n    }\n\n    &-text {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      button {\n        height: 46px;\n      }\n\n      &-logo {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n\n        img {\n          width: 209px;\n          height: 20px;\n        }\n        .large {\n          font-size: 33px;\n        }\n      }\n    }\n  }\n\n  &-content {\n    &-button {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      margin-top: 24px;\n      height: 64px;\n\n      button:first-child {\n        border-radius: 100px;\n        height: 40px;\n      }\n\n      div {\n        display: flex;\n        flex-direction: column;\n        align-items: end;\n\n        button {\n          border-radius: 4px !important;\n        }\n      }\n    }\n  }\n}\n\n.danger-text {\n  color: #BF303C;\n  margin-bottom: 8px;\n}\n\n.no-margin {\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
